<template>
  <el-form class="page-search" :inline="true" size="small">
    <el-form-item label="专业/通识">
      <el-select v-model="search.data.is_professional">
        <el-option label="专业" :value="1" />
        <el-option label="通识" :value="0" />
      </el-select>
    </el-form-item>
    <el-form-item v-if="search.data.is_professional" label="分类">
      <book-cate-selector v-model="search.data.tags" is-pro :clearable="true" />
    </el-form-item>
    <el-form-item label="书名">
      <el-input v-model="search.data.title" clearable />
    </el-form-item>
    <el-form-item label="作者">
      <el-input v-model="search.data.author" clearable />
    </el-form-item>
    <el-form-item label="出版社">
      <el-input v-model="search.data.publisher" clearable />
    </el-form-item>
    <el-form-item label="ISBN">
      <el-input v-model="search.data.isbn_13" clearable />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit"> 查询 </el-button>
    </el-form-item>
  </el-form>
</template>

<script lang="ts">
import { store } from './store'
import BookCateSelector from '@/views/credit-book/shared/book-cate-selector.vue'

export default {
  components: {
    BookCateSelector
  },

  data() {
    return {
      store,
      search: store.search
    }
  },

  methods: {
    onSubmit() {
      store.list.fetch({ reset: true })
    }
  }
}
</script>
